export const ru = {
  workspaces: {
    blogs: {
      title: 'Мои блоги',
      subtitle: 'Рабочие пространства, в которых вы участвуете.',
      empty: 'Вы пока не участвуете ни в одном блоге',
      emptyText: 'Создайте свой блог или попросите владельца добавить вас.',
      create: 'Новый блог',
      open: 'Открыть',
      created: 'Блог создан.',
    },
    roles: {
      owner: 'Владелец',
      editor: 'Редактор',
      viewer: 'Наблюдатель',
    },
    form: {
      name: 'Название',
      description: 'Описание',
      timezone: 'Часовой пояс',
      timezoneHint:
        'Значение из базы часовых поясов IANA, например Europe/Moscow, — выберите из списка. Ищите по любой части названия («Moscow», «Asia/», «New York») или по сдвигу («+3», «UTC+5:30», «-5»). В этом поясе задаются слоты и показываются даты блога.',
      timezoneSearch: 'Город, регион или сдвиг: Moscow, +3',
    },
    settings: {
      title: 'Настройки блога',
      sections: 'Разделы настроек',
      blog: 'Блог',
      members: 'Участники',
      channels: 'Каналы и слоты',
      schemes: 'Схемы',
      statuses: 'Статусы',
      entityTypes: 'Справочники',
      postFields: 'Поля постов',
      postFormats: 'Правила оформления',
      onlyOwner: 'Настройки блога доступны только владельцу.',
    },
    members: {
      title: 'Участники',
      add: 'Добавить участника',
      login: 'Логин пользователя',
      role: 'Роль',
      user: 'Пользователь',
      since: 'С',
      remove: 'Исключить',
      permissions: 'Наблюдатель читает всё; редактор работает с постами, медиа, справочниками и планом; владелец ещё и с настройками блога.',
    },
  },
};

export const en: typeof ru = {
  workspaces: {
    blogs: {
      title: 'My blogs',
      subtitle: 'Workspaces you are a member of.',
      empty: "You aren't a member of any blog yet",
      emptyText: 'Create your blog or ask an owner to add you.',
      create: 'New blog',
      open: 'Open',
      created: 'Blog created.',
    },
    roles: {
      owner: 'Owner',
      editor: 'Editor',
      viewer: 'Viewer',
    },
    form: {
      name: 'Name',
      description: 'Description',
      timezone: 'Time zone',
      timezoneHint:
        'A value from the IANA time zone database, e.g. Europe/Moscow — pick it from the list. Search by any part of the name (“Moscow”, “Asia/”, “New York”) or by offset (“+3”, “UTC+5:30”, “-5”). Slots and all blog dates use this time zone.',
      timezoneSearch: 'City, region or offset: Moscow, +3',
    },
    settings: {
      title: 'Blog settings',
      sections: 'Settings sections',
      blog: 'Blog',
      members: 'Members',
      channels: 'Channels and slots',
      schemes: 'Schemes',
      statuses: 'Statuses',
      entityTypes: 'References',
      postFields: 'Post fields',
      postFormats: 'Formatting rules',
      onlyOwner: 'Only the owner can change blog settings.',
    },
    members: {
      title: 'Members',
      add: 'Add member',
      login: 'User login',
      role: 'Role',
      user: 'User',
      since: 'Since',
      remove: 'Remove',
      permissions: 'Viewers read everything; editors work with posts, media, references and the plan; owners also manage blog settings.',
    },
  },
};
